import { createSelector } from 'reselect'

export const selectClientTeamMemberships = state => state.clientTeamMemberships

export const selectUnverifiedMembership = createSelector(
  selectClientTeamMemberships,
  memberships => memberships?.data?.find(membership => !membership.isVerified) || null
)

export const selectClientHasUnverifiedAgent = createSelector(selectUnverifiedMembership, unverifiedMembership => {
  console.log(unverifiedMembership)
  return unverifiedMembership !== null
})
